import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { query } from "lib/graphql/query"

export const getScimGroups = api(async function getScimGroups({ clientId } = {}) {
    return await query(
        gql`
            query getScimGroups($clientId: String) {
                getScimGroups(clientId: $clientId) {
                    _id
                    externalId
                    displayName
                    memberCount
                    created
                    updated
                }
            }
        `,
        { clientId },
        { returns: "getScimGroups", fetchPolicy: "network-only" }
    )
})

export const getScimGroupMappings = api(async function getScimGroupMappings({ clientId } = {}) {
    return await query(
        gql`
            query getScimGroupMappings($clientId: String) {
                getScimGroupMappings(clientId: $clientId) {
                    _id
                    externalId
                    displayName
                    license
                    roles
                    priority
                    created
                    updated
                }
            }
        `,
        { clientId },
        { returns: "getScimGroupMappings", fetchPolicy: "network-only" }
    )
})
